export const COMPONENT_BASE = 'ContractBillMonth';
export const COMPONENT_MAIN = `${COMPONENT_BASE}Main`;
export const COMPONENT_LIST = `${COMPONENT_BASE}List`;
export const COMPONENT_DETAIL = `${COMPONENT_BASE}Detail`;

export const TAB_LIST = 'list';
export const OPERATION_LIST_DEFAULT = 'list.default';

export const TAB_DETAIL = 'detail';
export const OPERATION_DETAIL_SHOW = 'detail.show';
export const OPERATION_DETAIL_ADD = 'detail.add';
export const OPERATION_DETAIL_EDIT = 'detail.edit';

export const FN_SET_OPERATION = 'setOperation';
export const FN_SET_TAB = 'setTab';

export const FN_LIST_QUERY = 'query';

export const FN_TO_DETAIL_SHOW = 'toDetailShow';
export const FN_TO_DETAIL_ADD = 'toDetailAdd';
export const FN_TO_DETAIL_EDIT = 'toDetailEdit';

export const MODEL_KEY_ID = 'id';

export const PERMISSION_ADD = null;
export const PERMISSION_EDIT = null;
export const PERMISSION_DELETE = null;

export const formatCurrency = (value, currency, decimals) => {
    let valueFloat = parseFloat(value);
    if (!isFinite(valueFloat) || (!valueFloat && valueFloat !== 0)) {
        return value;
    }
    currency = currency != null ? currency : '';
    decimals = decimals != null ? decimals : 2;
    let string = Math.abs(valueFloat).toFixed(decimals);
    let _int = decimals ? string.slice(0, -1 - decimals) : string;
    let i = _int.length % 3;
    let head = i > 0 ? (_int.slice(0, i) + (_int.length > 3 ? ',' : '')) : '';
    let _float = decimals ? string.slice(-1 - decimals) : '';
    let sign = valueFloat < 0 ? '-' : '';
    return sign + currency + head +
        _int.slice(i).replace(/(\d{3})(?=\d)/g, '$1,') +
        _float
};